import { CarouselLoader } from '../CarouselLoader';

export function renderLoader(loaderColor: string) {
  return function Loader() {
    return <CarouselLoader spinnerColor={loaderColor} />;
  };
}
